import { render } from "./imgListPage.vue?vue&type=template&id=012fe18c&scoped=true"
import script from "./imgListPage.vue?vue&type=script&lang=js"
export * from "./imgListPage.vue?vue&type=script&lang=js"

import "./imgListPage.vue?vue&type=style&index=0&id=012fe18c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012fe18c"]])

export default __exports__